import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    description:
      'You are about to set up your account without a card. You can still order one at any time from the “Credit Cards“ tab.',
    submit: 'Confirm',
    title: 'Continue without ordering a card',
  },
  fr: {
    description: `Vous vous apprêtez à configurer votre compte sans carte. Vous pourrez toujours en commander une à tout moment depuis l'onglet “Cartes Bancaires“.`,
    submit: 'Confirmer',
    title: 'Continuer sans commander de carte',
  },
});

export default locales;
